import { useEffect, useState } from 'react';

const PageLoader = ({ isLoading }) => {
  const [shouldRender, setShouldRender] = useState(isLoading);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setShouldRender(true);
      setIsAnimatingOut(false);
    } else if (shouldRender) {
      // Start exit animation
      setIsAnimatingOut(true);
      // Remove from DOM after animation completes
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 900); // Exit animation time (700ms curtain + 200ms buffer)
      return () => clearTimeout(timer);
    }
  }, [isLoading, shouldRender]);

  if (!shouldRender) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '68px', // Below navbar (adjust if navbar height is different)
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        pointerEvents: isAnimatingOut ? 'none' : 'all',
      }}
    >
      {/* White Curtain */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: '#ffffff',
          transform: isAnimatingOut ? 'translateY(-100%)' : 'translateY(0)',
          transition: 'transform 0.7s cubic-bezier(0.77, 0, 0.175, 1)',
          transitionDelay: isAnimatingOut ? '0.15s' : '0s',
          zIndex: 1,
          // Prevent curtain from going above its container (which starts below navbar)
          overflow: 'hidden',
        }}
      />

      {/* Logo Container */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2,
          opacity: isAnimatingOut ? 0 : 1,
          transform: isAnimatingOut ? 'scale(0.9)' : 'scale(1)',
          transition: 'opacity 0.3s ease, transform 0.3s ease',
        }}
      >
        <img
          src="https://ffbzkwlpbswgbngwvyvp.supabase.co/storage/v1/object/public/assets/logo/favicons/android-chrome-512x512.png"
          alt="Cargando..."
          style={{
            width: '120px',
            height: '120px',
            animation: 'spin 1.5s linear infinite',
            filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1))',
          }}
        />
      </div>

      {/* Keyframes */}
      <style>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default PageLoader;
